import { useState } from "react";

import Button from "../Button";

import AddressSelectorModal from "./AddressSelectorModal";

export default function AddressSection({ address }) {

  const [open, setOpen] = useState(false);

  return (
    <>
  <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-6">

    <div className="flex items-center justify-between mb-5">

      <div className="flex items-center gap-2">
        <span className="text-lg">📍</span>

        <h2 className="text-lg font-bold text-gray-800">
          آدرس تحویل
        </h2>
      </div>

      <Button
        variant="primary"
        onClick={() => setOpen(true)}
        children={"تغییر آدرس"}
      />

    </div>

    {address ? (
      <div className="space-y-3 text-sm">

        <div className="flex items-center gap-2 flex-wrap">

          <span className="font-semibold text-gray-800">
            {address.title}
          </span>

          <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
            {address.province_detail} - {address.city_detail}
          </span>

        </div>

        <p className="text-gray-600 leading-7">
          {address.address_text}
        </p>

      </div>
    ) : (
      <div className="bg-yellow-50 text-yellow-700 p-4 rounded-xl text-sm leading-6">
        آدرسی ثبت نشده است. برای انتخاب روش‌های ارسال توسط تأمین‌کننده یا
        شرکت حمل، ابتدا آدرس خود را ثبت نمایید.
      </div>
    )}

  </div>

  {open && (
    <AddressSelectorModal
      onClose={() => setOpen(false)}
    />
  )}
</>

  );
}
